import { render, staticRenderFns } from "./WordDictation1.vue?vue&type=template&id=97587cb4&"
import script from "./WordDictation1.vue?vue&type=script&lang=js&"
export * from "./WordDictation1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports